// src/beta/components/AttributionList.tsx
import type { V1Attribution } from '@/beta/types/dossier';

interface Props {
  attributions: V1Attribution[];
}

function dateRange(a: V1Attribution): string {
  if (!a.date_from) return '—';
  if (!a.date_to) return `${a.date_from}—present`;
  return `${a.date_from}—${a.date_to}`;
}

/** § 6.4 (6): Restoration attributions — restorer name, role, date range, notes. */
export function AttributionList({ attributions }: Props) {
  if (attributions.length === 0) {
    return (
      <p style={{ color: 'var(--vm-stone)', fontSize: 13, fontFamily: 'var(--vm-font-body)' }}>
        No restoration attributions on file.
      </p>
    );
  }

  return (
    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {attributions.map((a) => (
        <li
          key={a.id}
          style={{
            padding: 'var(--vm-s-2) 0',
            borderBottom: '1px solid var(--vm-border)',
          }}
        >
          <div
            style={{
              fontFamily: 'var(--vm-font-heading)',
              fontSize: 18,
              color: 'var(--vm-warm-white)',
            }}
          >
            {a.restorer_name}
          </div>
          <div
            style={{
              marginTop: 4,
              fontFamily: 'var(--vm-font-heading)',
              fontSize: 11,
              letterSpacing: '0.3em',
              textTransform: 'uppercase',
              color: 'var(--vm-stone)',
            }}
          >
            {a.role} · {dateRange(a)}
          </div>
          {a.notes && (
            <p
              style={{
                marginTop: 'var(--vm-s-1)',
                fontFamily: 'var(--vm-font-body)',
                fontSize: 13,
                color: 'var(--vm-warm-white)',
                lineHeight: 1.5,
              }}
            >
              {a.notes}
            </p>
          )}
        </li>
      ))}
    </ul>
  );
}
